import {connect} from "react-redux";
import LuissState from "../../luiss_state";
import {ACTIONS} from "../../actions";
import HomePage from "../../../containers/home_page/home_page";
import {API_CONFIG} from "../../../config/api_config";
import {BreadcrumbPiece} from "../../../utils/menu";

const mapStateToProps = (state: LuissState | any) => ({
    // This is the path where we load the home page data
    url: `${API_CONFIG.BASE_URL + API_CONFIG.HOME_CONTENTS_PATH}/${state.app.language}`
});

const mapDispatchToProps = (dispatch: any) => ({
    menuColorCallback: (color: string) => {
        dispatch(ACTIONS.changeBaseColor(color));
    },
    breadcrumbCallback: (breadcrumb: BreadcrumbPiece[]) => {
        dispatch(ACTIONS.changeBreadcrumb(breadcrumb))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
